import React from "react";
import { connect } from "react-redux";

import FilterBar from "./filterBar"
import EditControls from "./editControls";


const RegisterToolbar = ({ editable }) => (
    <div>
        <FilterBar>
            { editable && <EditControls /> }
        </FilterBar>
    </div>
);

export default connect((state) => ({ editable: state.immutableEditing.editable }))(RegisterToolbar)
